import { Logo } from './logo';

export function SplashScreen() {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center bg-background text-center">
      <div className="relative flex items-center justify-center">
        <div className="absolute h-48 w-48 rounded-full animate-glowing-ring"></div>
        <Logo width={160} height={160} className="animate-pulse" priority />
      </div>
      <div className="relative mt-8 max-w-lg px-4">
        <p className="text-lg font-bold text-foreground">
          Someone around Africa needs Your Skills, Products & Talent...
        </p>
        <p className="mt-2 text-base text-muted-foreground">
          Engage, Trade, Monetize and Earn across borders.
        </p>
      </div>
    </div>
  );
}
